import { useMemo } from 'react';
import { Theme, css, useTheme } from '@emotion/react';
import { borderRadius } from 'client/Theme';

const placeholderImage = (theme: Theme) => `
  data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'
  fill='${theme.color.grey[80].replace(
    '#',
    '%23'
  )}' viewBox='0 0 256 256'%3E%3Cpath d='M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,
  80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,
  0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,
  1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z'%3E%3C/path%3E%3C/svg%3E
`;

export const ProfilePicture = ({ accountID }: { accountID?: number | null }) => {
  const theme = useTheme();
  const placeholderSrc = useMemo(() => placeholderImage(theme), [theme.color.grey[80]]);
  return <img src={accountID ? `https://hotshot.b-cdn.net/account/${accountID}.svg` : placeholderSrc} css={imageStyle} />;
};

const imageStyle = (theme: Theme) => css`
  height: 72px;
  width: 72px;
  border-radius: ${borderRadius}px;
  background-color: ${theme.color.grey[60]};
`;
